import { ContactMail } from '../../Contact/ContactMail';
import { ContactPhone } from '../../Contact/ContactPhone';
import { FC } from 'react';
import { Spacer } from 'internalLibrary';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import styles from './DesktopFooter.module.scss';

export interface DesktopFooterProps {
  className?: string;
  content: {
    businessHours: string;
    email: string;
    phone: string;
    termsAndConditionsText?: string;
  };
  center?: boolean;
}

const DesktopFooter: FC = () => {
  const { t } = useTranslation();

  return (
    <div className={classNames(styles.footer, styles.center)}>
      <div className={styles.contact}>
        <div className={styles['contact-info']}>
          <ContactMail email={t('email')} />
          <Spacer marginRight={'30px'} />
          <ContactPhone phone={t('phone')} />
        </div>
        <div
          className={styles['business-hours']}
          dangerouslySetInnerHTML={{ __html: t('businessHours') }}
        />
      </div>
    </div>
  );
};

export default DesktopFooter;
